import { Dialog, TextField } from "@mui/material";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { useState } from "react";
import { TFechamentos } from "../../types/api/financeiro/pesquisar-fechamentos";

export default function SelectConfigFechamentos({
    value,
    onChange,
    required = false,
    error = false,
    isDisabled = false,
    extraParams = {}
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Configuração`}
                variant="outlined"
                fullWidth
                disabled={isDisabled}
                onClick={() => {
                    if (isDisabled) return
                    setOpenModal(true)
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, extraParams }}
                        title="Selecione um configuração"
                        queryPath="/financeiro/conta-corrente-consumo/pesquisar-configuracoes"
                        getItemKey={(item) => item?.id?.toString() || ''}
                        getItemLabel={(item) => item ? `${item.id} - ${item.nome}` : ''}
                        defaultValue={value}
                        onChange={(value) => {
                            onChange(value as TObjValueFechamentos)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TFechamentos | null,
    onChange: (arg: TObjValueFechamentos | null) => void
    error?: boolean
    required?: boolean;
    isDisabled?: boolean;
    extraParams?: { [key: string]: any };
}

export type TObjValueFechamentos = TFechamentos